import React from 'react';
import ill_jobs from '../../../images/ill-jobs.png';
export default function AvailableJobsDefault() {
  return (
    <div className="text-center px-4 py-2 md:py-40">
      <div className="inline-flex justify-center mb-8">
        <img src={ill_jobs} className="w-1/3" alt="404 illustration" />
      </div>
      <div className="mb-6 text-gray-400 text-2xl">
        Select a job post to view{' '}
      </div>
    </div>
  );
}
